import React from "react";
import USER_ROLES from "pages/PageRoot/constants";
import { Navigate } from "react-router-dom";
import { routes } from "config/routes";
import { useAppSelector } from "store/hooks/useAppSelector";
import IPrivateRouteProps from "pages/PageRoot/types";
import MainPage from "pages/MainPage";

const RestrictedRoute = ({ children }: IPrivateRouteProps) => {
  const isLoggedIn = useAppSelector((state) => state.auth.login);
  const userRole = USER_ROLES.ADMIN;

  const defineHomePageByRole = (role: string): JSX.Element => {
    switch (role) {
      case USER_ROLES.ADMIN:
        return <Navigate to={routes.orders.root} replace />;
      case USER_ROLES.OPERATOR:
        return <Navigate to={routes.orders.root} replace />;
      default:
        return <MainPage />;
    }
  };

  const homePage = defineHomePageByRole(userRole);

  return isLoggedIn ? homePage : children;
};

export default RestrictedRoute;
